import { AssignPanel } from './components/event_details/assign_panel'
import { AvailabilityPanel } from './components/event_details/availability_panel'
import { DurationPanel } from './components/event_details/duration_panel'
import { GroupEventPanel } from './components/event_details/group_event_panel'
import { HostsPanel } from './components/event_details/hosts_panel'
import { LocationPanel } from './components/event_details/location_panel'
import { BookingPageOptionsPanel } from './more_options/booking_page_options_panel'
import { ConfirmationPagePanel } from './more_options/confirmation_page_panel'
import { DescriptionPanel } from './more_options/description_panel'
import { FreeBusyRulesPanel } from './more_options/free_busy_rules_panel'
import { InviteeFormPanel } from './more_options/invitee_form_panel'
import { LimitsAndBuffersPanel } from './more_options/limits_and_buffers_panel'
import { NotificationsPanel } from './more_options/notifications_panel'
import { PaymentPanel } from './more_options/payment_panel'

export const PANELS = {
  nameAndColor: 'nameAndColor',
  duration: 'duration',
  location: 'location',
  availability: 'availability',
  groupEvent: 'groupEvent',
  hosts: 'hosts',
  assign: 'assign',
  description: 'description',
  limitsAndBuffers: 'limitsAndBuffers',
  freeBusyRules: 'freeBusyRules',
  bookingPageOptions: 'bookingPageOptions',
  inviteeForm: 'inviteeForm',
  payment: 'payment',
  notifications: 'notifications',
  confirmationPage: 'confirmationPage'
}

// these map the panel key to the lock name for sections that show as locked for parent MET
export const panelLockNames = {
  [PANELS.nameAndColor]: 'v3_name_and_color',
  [PANELS.duration]: 'v3_duration',
  [PANELS.availability]: 'v3_availability',
  [PANELS.groupEvent]: 'v3_invitee_limit',
  [PANELS.description]: 'v3_description',
  [PANELS.limitsAndBuffers]: 'v3_limits_and_buffers',
  [PANELS.bookingPageOptions]: 'v3_booking_page',
  [PANELS.inviteeForm]: 'v3_invitee_form',
  [PANELS.payment]: 'v3_payment_method',
  [PANELS.notifications]: 'v3_notifications',
  [PANELS.confirmationPage]: 'v3_confirmation_page'
}

export const panelComponentsByKey = {
  [PANELS.duration]: DurationPanel,
  [PANELS.location]: LocationPanel,
  [PANELS.availability]: AvailabilityPanel,
  [PANELS.groupEvent]: GroupEventPanel,
  [PANELS.hosts]: HostsPanel,
  [PANELS.assign]: AssignPanel,
  [PANELS.description]: DescriptionPanel,
  [PANELS.limitsAndBuffers]: LimitsAndBuffersPanel,
  [PANELS.freeBusyRules]: FreeBusyRulesPanel,
  [PANELS.bookingPageOptions]: BookingPageOptionsPanel,
  [PANELS.inviteeForm]: InviteeFormPanel,
  [PANELS.payment]: PaymentPanel,
  [PANELS.notifications]: NotificationsPanel,
  [PANELS.confirmationPage]: ConfirmationPagePanel
}
